import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "../../annotations";
import { Page, User } from "./dtos";

const USERS_SERVICE = `${Constants.API_URL}/bedrock/users`;

export interface GetUsersParams {
  userType: User.Type | User.Type[];
  page?: number;
  perPage?: number;
}

export class UsersServices {
  @scCatchServiceException()
  static async getUsers(params: GetUsersParams): Promise<Page<User>> {
    const { data } = await axios.get<Page<User>>(USERS_SERVICE, {
      params: {
        userType: params.userType,
        page: params.page || 1,
        perPage: params.perPage ?? 100,
      },
    });
    return data;
  }
}
